import Field from "components/shared/field";
import Select from "components/shared/select";
import { logistTaskTypesEnum } from "helpers/enums";
import { requiredField } from "helpers/validators";
import React, { useState } from "react";

export default function CancelTaskForm(props) {
    const [cancellationReasonId, setCancellationReasonId] = useState();
    const [comment, setComment] = useState();
    const [invalid, setInvalid] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const { logistTaskCancellationReason } = props.enums;

    const onSubmit = () => {
        if (cancellationReasonId || comment) {
            props.cancelAction(showInput ? { comment } : { cancellationReasonId }).then(() => props.back());
        } else {
            setInvalid(true);
        }
    };

    const inputBottomText = () => {
        if (props.type !== logistTaskTypesEnum.NeedDriverShift) {
            return null;
        }
        return (
            <span className="link small " onClick={() => setShowInput(!showInput)}>
                {showInput ? "или выбрать из списка" : "или написать свою причину"}
            </span>
        );
    };

    return (
        <div className={invalid ? "panel--invalid" : ""}>
            <div className="mb-3">
                {showInput ? (
                    <Field
                        inputProps={{ name: "comment" }}
                        onChange={({ value }) => setComment(value)}
                        value={comment ?? ""}
                        validators={[requiredField]}
                    />
                ) : (
                    <Select
                        inputProps={{ name: cancellationReasonId }}
                        options={logistTaskCancellationReason || []}
                        onChange={({ value }) => setCancellationReasonId(value)}
                        value={cancellationReasonId}
                        validators={[requiredField]}
                        menuPortalTarget={document.body}
                    />
                )}
                {inputBottomText()}
            </div>
            <div className="btn btn-sm btn-secondary" onClick={onSubmit}>
                Отказать
            </div>
        </div>
    );
}
